/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  VerifyUserOptions,
  VerifyUserStatus200,
  VerifyUserStatus400,
  VerifyUserStatus404,
  VerifyUserStatus500,
} from '../types/VerifyUser'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { verifyUser } from '../clients/verifyUser'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const verifyUserMutationKey = () => [{ url: '/v1/user/:user_id/verify' }] as const

export function verifyUserMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = verifyUserMutationKey()
  return mutationOptions<
    VerifyUserStatus200,
    ResponseErrorConfig<VerifyUserStatus400 | VerifyUserStatus404 | VerifyUserStatus500>,
    VerifyUserOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path }) => {
      return verifyUser({ ...config, path, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Verify a user by ID
 * {@link /v1/user/:user_id/verify}
 */
export function useVerifyUser<TContext>(
  options: {
    mutation?: UseMutationOptions<
      VerifyUserStatus200,
      ResponseErrorConfig<VerifyUserStatus400 | VerifyUserStatus404 | VerifyUserStatus500>,
      VerifyUserOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? verifyUserMutationKey()

  const baseOptions = verifyUserMutationOptions(config) as UseMutationOptions<
    VerifyUserStatus200,
    ResponseErrorConfig<VerifyUserStatus400 | VerifyUserStatus404 | VerifyUserStatus500>,
    VerifyUserOptions,
    TContext
  >

  return useMutation<
    VerifyUserStatus200,
    ResponseErrorConfig<VerifyUserStatus400 | VerifyUserStatus404 | VerifyUserStatus500>,
    VerifyUserOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    VerifyUserStatus200,
    ResponseErrorConfig<VerifyUserStatus400 | VerifyUserStatus404 | VerifyUserStatus500>,
    VerifyUserOptions,
    TContext
  >
}
